import React from "react";
import { Link } from "react-router-dom";

// CategoryBadge Component for reusability and dynamic styling
const CategoryBadge = ({ category, color }) => {
  const badgeStyle = {
    backgroundColor: color,
    padding: "5px 10px",
    borderRadius: "5px",
    marginRight: "10px",
    fontSize: "0.75rem",
    fontWeight: "700",
    color: "#fff",
  };

  return <div style={badgeStyle}>{category}</div>;
};

export default function BlogPageBox6() {
  return (
    <div className="blog-page-parent">
      {/* Date and Author Section */}
      <div className="blog-page-date-author">
        <span>Published</span>
        <span className="blog-page-date"> February 1, 2025</span>
        <span> by</span>
        <span className="blog-page-author"> FlexNet Team</span>
      </div>

      {/* Title Section */}
      <div className="blog-page-title">
        Partnering for Success: How FlexNet Empowers Solution and Reseller
        Partners
      </div>

      {/* Category Badges */}
      <div className="blog-page-categories">
        {[
          { name: "5G Technology", color: "#6366F1" },
          { name: "Business Partnerships", color: "#22C55E" },
          { name: "Enterprise Solutions", color: "#F59E0B" },
        ].map((category, index) => (
          <CategoryBadge
            key={index}
            category={category.name}
            color={category.color}
          />
        ))}
      </div>

      {/* Blog Content */}
      <div className="blog-page-info">
        <h2>Introduction</h2>
        <p>
          Behind every great innovation is a team of dedicated partners working
          together to make it happen. At FlexNet, we believe in the power of
          collaboration to drive success, innovation, and growth. That’s why our
          Solution and Reseller Partner Programs are designed to provide
          unmatched opportunities for businesses looking to make an impact in
          the private 4G/5G space. Whether you’re offering innovative solutions
          or expanding FlexNet’s reach, partnering with us means becoming a key
          player in the future of connectivity.
        </p>

        <h2>Solution Partners: Innovating Together</h2>
        <h3>Who Are Solution Partners?</h3>
        <p>
          Solution Partners are at the forefront of innovation. These are the
          device manufacturers, application developers, and technology providers
          who bring cutting-edge solutions to life—solutions that leverage the
          power of private 4G/5G to solve real-world challenges.
        </p>

        <h3>What You Bring:</h3>
        <ul>
          <li>
            Devices or applications that drive efficiency, productivity, and
            innovation across industry verticals.
          </li>
          <li>
            Expertise in creating solutions that integrate seamlessly with
            FlexNet’s private 4G/5G platform.
          </li>
        </ul>

        <h3>What You Get:</h3>
        <ul>
          <li>
            <strong>Access to the FlexNet Marketplace:</strong> Showcase your
            solutions directly to customers across industries through our
            integrated Marketplace.
          </li>
          <li>
            <strong>Collaborative Innovation:</strong> Work with us to solve
            specific industry challenges and create value for end-users.
          </li>
          <li>
            <strong>Global Visibility:</strong> Reach a broad audience of
            FlexNet customers looking for tailored solutions.
          </li>
        </ul>

        <h3>Why It Matters:</h3>
        <p>
          As a Solution Partner, you’re not just selling a product—you’re
          shaping the future of how industries connect and operate.
        </p>

        <h2>Reseller Partners: Expanding Horizons</h2>
        <h3>Who Are Reseller Partners?</h3>
        <p>
          Reseller Partners are trusted providers with the reach and expertise
          to deliver FlexNet’s solutions to businesses worldwide. By becoming a
          Reseller Partner, you’ll help scale FlexNet’s impact, bringing
          advanced connectivity to industries in need.
        </p>

        <h3>What You Bring:</h3>
        <ul>
          <li>A strong presence in one or more industries or geographies.</li>
          <li>
            Expertise in understanding customer needs and matching them with
            innovative solutions.
          </li>
        </ul>

        <h3>What You Get:</h3>
        <ul>
          <li>
            <strong>Comprehensive Training and Support:</strong> Gain the tools
            and knowledge needed to sell FlexNet effectively.
          </li>
          <li>
            <strong>Revenue Growth Opportunities:</strong> Expand your portfolio
            with high-value private 4G/5G solutions and applications.
          </li>
          <li>
            <strong>Dedicated Resources:</strong> Access co-marketing
            initiatives, technical assistance, and exclusive partner benefits.
          </li>
        </ul>

        <h3>Why It Matters:</h3>
        <p>
          Reseller Partners are essential in making FlexNet accessible to
          businesses everywhere, empowering them to thrive in a connected world.
        </p>

        <h2>Why Partner with FlexNet?</h2>
        <ul>
          <li>
            <strong>1. Collaborative Success:</strong> FlexNet’s success is
            rooted in partnerships. By working together, we create solutions
            that drive real impact.
          </li>
          <li>
            <strong>2. Industry Leadership:</strong> Be part of an ecosystem
            that’s shaping the future of private 4G/5G networks.
          </li>
          <li>
            <strong>3. Access to Innovation:</strong> Partner with a platform
            that’s constantly evolving to meet industry needs, giving you a
            competitive edge.
          </li>
          <li>
            <strong>4. Revenue Growth:</strong> Tap into the growing demand for
            private networks and industry-specific applications to grow your
            business.
          </li>
          <li>
            <strong>5. Ongoing Support:</strong> From technical assistance to
            marketing resources, FlexNet is with you every step of the way.
          </li>
        </ul>

        <h2>Let’s Build the Future Together</h2>
        <p>
          Partnering with FlexNet means being part of something bigger. It’s
          about creating solutions, reaching new markets, and driving
          innovation—together. Whether you’re developing cutting-edge
          technologies as a Solution Partner or bringing our solutions to new
          industries as a Reseller Partner, your contribution matters.
        </p>

        <h2>Ready to partner with FlexNet and transform connectivity?</h2>
        <p className="font-bold text-lg">
          <Link to="/partners">
            <span className="text-blue-600">Become a Solution Partner</span>
          </Link>
          |
          <Link to="/partners">
            <span className="text-blue-600">Become a Reseller Partner</span>
          </Link>
        </p>
      </div>
    </div>
  );
}
